import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FaqBox from "../../components/common/faq/faq";
import ClaimsSkeleton from "./claimsSkeleton";
import ServiceGrid from "../../components/common/serviceCards/serviceCards";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import {
  getCrmClaims,
  selectCrmClaims,
  selectCrmClaimsLoading,
} from "../../redux/features/crm/crmClaimSlice";
import { selectFaqsData } from "../../redux/features/faqsSlice";
import { selectLoginTokenInfo } from "../../redux/features/loginRegisterSlice";
import { getClientSource } from "../../utils/getClientSource";
import { FAQS_TYPES } from "../dashboard/data";
import ActiveClaimCard from "./activeClaimCard";
import { FILE_A_CLAIM, quickActions, TRACK_A_CLAIM } from "./data";

const FileClaim = () => {
  const navigate = useNavigate();
  const translate = useLanguageTranslate();
  const serviceClickHandler = (action_type) => {
    if (action_type == FILE_A_CLAIM) {
      navigate("/motor-insurance/file-new-claim");
    } else if (action_type == TRACK_A_CLAIM) {
      navigate("/motor-insurance/track-claim");
    }
  };
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const crmClaims = useSelector(selectCrmClaims);
  const dispatch = useDispatch();
  const IsLoading = useSelector(selectCrmClaimsLoading);

  useEffect(() => {
    if (loginTokenInfo) {
      const payload = {
        Cpr: loginTokenInfo?.userName,
        Channel: getClientSource(),
      };
      dispatch(getCrmClaims(payload)); // Use the correct action creator
    }
  }, [loginTokenInfo, dispatch]);

  const faqs = useSelector(selectFaqsData);

  const fileClaimFaqs = useMemo(() => {
    if (!faqs?.data) return [];

    // In v5, 'type' is directly on the item (no attributes)
    const claimCategory = faqs.data.find(
      (each) => each?.type === FAQS_TYPES.claim
    );

    if (!claimCategory) return [];

    const items = Array.isArray(claimCategory.c_p_faqs)
      ? claimCategory.c_p_faqs
      : [];

    return items.map((faq, idx) => {
      // In your current data question is null, so fallback to category title
      const question_en =
        faq?.question?.title_en || claimCategory?.title?.title_en || "";
      const question_ar =
        faq?.question?.title_ar || claimCategory?.title?.title_ar || "";

      const answer_en = faq?.answer?.content_en || "";
      const answer_ar = faq?.answer?.content_ar || "";

      return {
        id: faq.id ?? idx,
        question_en,
        question_ar,
        answer_en,
        answer_ar,
      };
    });
  }, [faqs]);

  return (
    <div className="max767:pb-32 ipad:p-4">
      <div className="flex flex-col p-5">
        <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 mt-0 max767:mt-24">
          {translate("Quick Actions", "الإجراءات السريعة")}
        </h1>
        <div className="fileclaim-box">
          <ServiceGrid
            services={quickActions}
            serviceClickHandler={serviceClickHandler}
          />
        </div>
      </div>
      {loginTokenInfo && (
        <div className="max767:p-4 p-5">
          <div className="justify-between flex pt-0 mt-0 max767:mt-0 max767:pt-2">
            <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 max767:pl-0">
              {translate("Claims", "المطالبات")}
            </h1>
            {/* <span className="flex flex-col items-center gap-2.5 border bg-white px-3 py-1 rounded-md text-[#48535B] text-center text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:border-0">
              {translate("View Closed Claims", "عرض المطالبات المغلقة")}
            </span> */}
          </div>
          <div className="grid items-start gap-4 pl-0 pr-0 pb-0 pt-3 max767:flow-root max767:pl-0 grid-cols-3 w-[1200px] max-w-[100%] ipad:grid-cols-2">
            {IsLoading && !crmClaims?.length && <ClaimsSkeleton />}
            {crmClaims?.length > 0
              ? [...crmClaims]
                  .sort((a, b) => b.IntimationDate - a.IntimationDate)
                  .map((each, index) => (
                    <ActiveClaimCard
                      key={each.CaseNumber || index}
                      claim={each}
                    />
                  ))
              : !IsLoading && (
                  <p>{translate("No claims available.", "لا توجد مطالبات.")}</p>
                )}
          </div>
        </div>
      )}
      <div className="flex flex-col p-4 w-[700px] max-w-full p-5">
        <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] mt-4 mb-4">
          {translate("FAQs", "الأسئلة الشائعة")}
        </h1>
        {fileClaimFaqs?.map((each) => (
          <FaqBox
            key={each.id}
            question={translate(each.question_en, each.question_ar)}
            answer={translate(each.answer_en, each.answer_ar)}
          />
        ))}
      </div>
    </div>
  );
};

export default FileClaim;
